import { render, staticRenderFns } from "./tab-select-type-store.vue?vue&type=template&id=6dd59636&"
import script from "./tab-select-type-store.vue?vue&type=script&lang=js&"
export * from "./tab-select-type-store.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports